import * as types from '../types';
export function changeIsClose() {
  return {
    type: types.ISCLOSE_CHANGE,   
    }
  };
